import gql from 'graphql-tag'

export const GET_USERS = gql`
    query get_users($filter: ModelUserProfileFilterInput) {
        listUserProfiles(filter: $filter, limit: 2000) {
            items {
                countryId
                createdOn
                email
                firstName
                id
                lastLoginDate
                country {
                    name
                    abbreviation
                }
                dateOfBirth
                lastName
                availableRoles
                activeRole
                notifyEmail
                notifyPhone
                payableAddress
                phone
            }
        }
    }
`
